(function($) {
    var w4d = w4d || {};

    w4d.product_gallery = {

        init: function () {
            var galleries = document.querySelectorAll('.js-product-gallery');
            for (var i = 0; i < galleries.length; i++) {
                var gallery = galleries[i];
                this.build_thumbnails(gallery);
                this.init_gallery();
            }
            this.register_events();
            this.init_scroll_arrows();
            this.sticky_sidebar();
        },
        init_scroll_arrows: function () {
            const $thumbContainer = $('.product-gallery__thumbnails.js-thumbnails');

            if (!$thumbContainer.length) return;

            const $wrapper = $thumbContainer.closest('.product-gallery__thumbnails-wrapper');
            const $thumbnails = $thumbContainer.find('.js-thumbnail');

            if ($thumbnails.length > 6 && $wrapper.height() > $wrapper.width()) {

                $wrapper.css('position', 'relative');

                // Dodaj strelice (samo ako već ne postoje)
                if (!$wrapper.find('.w4d-scroll-up').length) {
                    $wrapper.append('<div class="w4d-thumb-scroll w4d-scroll-up">&#9650;</div>');
                }

                if (!$wrapper.find('.w4d-scroll-down').length) {
                    $wrapper.append('<div class="w4d-thumb-scroll w4d-scroll-down">&#9660;</div>');
                }

                function updateScrollButtons() {
                    const scrollTop = $thumbContainer.scrollTop();
                    const maxScroll = $thumbContainer[0].scrollHeight - $thumbContainer.outerHeight();

                    $('.w4d-scroll-up').toggle(scrollTop > 0);
                    $('.w4d-scroll-down').toggle(scrollTop < maxScroll - 5);
                }

                // Scroll eventi
                $(document).on('click', '.w4d-scroll-up', function () {
                    $thumbContainer.animate({ scrollTop: $thumbContainer.scrollTop() - 180 }, 300, updateScrollButtons);
                });

                $(document).on('click', '.w4d-scroll-down', function () {
                    $thumbContainer.animate({ scrollTop: $thumbContainer.scrollTop() + 180 }, 300, updateScrollButtons);
                });

                $thumbContainer.on('scroll', updateScrollButtons);
                updateScrollButtons();
            }
        },

        /**
         * register_events - All events you want to register for this module
         *
         * @return {Undefined}
         */
        register_events: function () {
            var thumbnails = document.querySelectorAll('.js-thumbnail');
            for (var i = 0; i < thumbnails.length; i++) {
                thumbnails[i].addEventListener('click', this.handle_thumbnail_click.bind(this));
            }
        },

        /**
         * sticky_sidebar - Add fake sticky sidebar with margin top
         *
         * @return {Undefined}
         */
        sticky_sidebar: function() {
            const sidebarWrapper = document.querySelector('.shop-sidebar-wrapper');
            const sidebar = document.querySelector('.shop-sidebar');

            if (sidebar && sidebarWrapper) {
                const sidebarHeight = sidebar.offsetHeight;
                const sidebarWrapperHeight = sidebarWrapper.offsetHeight;

                const wrapperTop = sidebarWrapper.offsetTop; // Distance of sidebar wrapper from the top of the page
                const sidebarTop = sidebar.offsetTop; // Distance of sidebar from the top of the page
                const maxMarginTop = sidebarWrapperHeight - sidebarHeight; // Max margin top to ensure it doesn't overflow
                const body = document.body;
                const hasAdminBar = body.classList.contains('admin-bar');
                const offset = hasAdminBar ? 160 : 128;

                window.addEventListener('scroll', function () {
                    var mediaQueryMd = window.matchMedia('(min-width: 992px)');

                    if (mediaQueryMd.matches) {
                        const scrollY = window.scrollY; // Current scroll position

                        // Calculate margin top only after the viewport has hit the top of the sidebar
                        let marginTop = 0;
                        if (scrollY >= sidebarTop) {
                            marginTop = Math.min(Math.max(scrollY - wrapperTop, 0), maxMarginTop + offset); // Limit margin to within bounds
                        }

                        sidebar.style.marginTop = `${marginTop > offset ? (marginTop - (scrollY >= sidebarTop ? offset : 0)) : 0}px`;
                    }
                });
            }
        },

        /**
         * Build thumbnails dynamically from gallery
         *
         * @param {Element} gallery
         */
        build_thumbnails: function(gallery) {
            // Find the parent product gallery container
            var productGallery = gallery.closest('.product-gallery');
            var thumbnailsContainer = productGallery.querySelector('.js-thumbnails');

            // Get all the anchor elements (each gallery image)
            var galleryItems = gallery.querySelectorAll('a');
            for (var i = 0; i < galleryItems.length; i++) {
                var galleryItem = galleryItems[i];
                var img = galleryItem.querySelector('img');

                // Create thumbnail container
                var thumbnail = document.createElement('div');
                thumbnail.classList.add('product-gallery__thumbnail', 'js-thumbnail');
                thumbnail.dataset.id = img.dataset.id ?? 0;

                // Set the first thumbnail to active
                if (i === 0) {
                    thumbnail.classList.add('active');
                }

                // Clone the image from the gallery and append to thumbnail
                var thumbnailImage = img.cloneNode(true);
                thumbnail.appendChild(thumbnailImage);

                // Append the thumbnail to the thumbnails container
                thumbnailsContainer.appendChild(thumbnail);
            }
        },

        /**
         * Init_gallery - Gallery init
         *
         * @return {Undefined}
         */
        init_gallery: function() {
            lightGallery(document.getElementById('lightgallery'), {
                plugins: [lgZoom, lgThumbnail, lgVideo, lgAutoplay],
                licenseKey: '973A50AB-B5EA-4B1C-9DBC-9E71F46A7925',
                speed: 500,
                zoomFromOrigin: false,
                download: false,
                autoplayFirstVideo: true,
            });
        },

        /**
         * handle_thumbnail_click - Handles the click on a thumbnail to toggle 'active' class
         *
         * @param {Event} e
         */
        handle_thumbnail_click: function(e) {
            if (e.fromVariationUpdate) return;

            e.preventDefault();

            const clickedThumbnail = e.currentTarget;
            if (!clickedThumbnail) return;

            // Aktiviraj kliknuti thumbnail
            document.querySelectorAll('.js-thumbnail').forEach(el => el.classList.remove('active'));
            clickedThumbnail.classList.add('active');

            // Aktiviraj odgovarajuću sliku u galeriji (ako postoji)
            const thumbnails = Array.from(document.querySelectorAll('.js-thumbnail'));
            const galleryLinks = document.querySelectorAll('.js-product-gallery > a');
            const index = thumbnails.indexOf(clickedThumbnail);

            if (index !== -1 && galleryLinks[index]) {
                galleryLinks.forEach(el => el.classList.remove('active'));
                galleryLinks[index].classList.add('active');
            }

            // Uzmi image_id iz thumbnaila
            const imageId = parseInt(clickedThumbnail.dataset.id);
            if (!imageId || isNaN(imageId)) return;

            // Nađi varijaciju prema image_id
            const productVariations = $('.variations_container').data('product_variations');
            if (!Array.isArray(productVariations)) return;

            const matchedVariation = productVariations.find(v => parseInt(v.image_id) === imageId);
            if (!matchedVariation) return;

            // Postavi selektovane atribute
            const $variationSelects = $('.variations select');
            Object.entries(matchedVariation.attributes).forEach(([attrName, attrValue]) => {
                $variationSelects.filter(`[name="${attrName}"]`).val(attrValue).trigger('change');
            });

            // Pokreni ažuriranje varijacije
            if (typeof window.W4D_Cart?.updateVariationData === 'function') {
                window.W4D_Cart.updateVariationData(matchedVariation);
            }
        }



    }

    $(document).ready(function () {
        w4d.product_gallery.init();
    });

    window.w4d = w4d;
})(jQuery);